/** Раздел словаря «lobby»: лобби (ui/Lobby.tsx), ожидание игроков (ui/WaitingRoom.tsx), правила (ui/Rules.tsx). */
export const lobby = {
  // ── лобби ──
  title: 'Лобби',
  intro: 'Прогноз движения скрытого индекса из трёх акций S&P 500: сначала только график, затем шкала, и лишь в последнем круге — состав.',
  balance: 'Баланс',
  atTables: 'За столами',
  openTables: 'Открыто столов',
  tables: 'Столы',
  rulesBtn: 'Правила и расчёт выигрыша',
  creditsNote: 'Игровые кредиты: нельзя купить, продать, передать или обменять.',
  restore: 'Восстановить стартовый баланс {amount|cr}',
  'stat.games': 'Розыгрышей',
  'stat.winRate': 'Винрейт',
  'stat.net': 'Итог',
  'stat.avgError': 'Средняя ошибка',
  profileLink: 'Профиль, история и статистика',
  verifyTitle: 'Проверка розыгрыша',
  verifyTextBefore: 'После каждого розыгрыша участник может скачать подписанный пакет: все ходы, состав и исходные котировки акций, расчёт и проводки. Его можно проверить здесь или утилитой',
  verifyTextAfter: 'и сравнить котировки с любым внешним источником.',
  verifyBtn: 'Проверить файл пакета…',

  // ── ход розыгрыша (лобби и ожидание) ──
  flowTitle: 'Как проходит розыгрыш',
  'flow.prep': 'Подготовка',
  'flow.prepText': 'взнос N в банк, хеш состава опубликован',
  'flow.prepTextAnte': 'взнос {ante|cr} в банк, хеш состава опубликован',
  'flow.round1': 'Круг 1 · график',
  'flow.round1Text': 'без шкалы цен; выбор направления',
  'flow.round2': 'Круг 2 · шкала',
  'flow.round2Text': 'цены и расстояния в пунктах',
  'flow.round2TextWr': 'цены и пункты; направление можно сменить',
  'flow.round3': 'Круг 3 · состав',
  'flow.round3Text': 'три акции раскрыты; число пунктов',
  'flow.round3TextWr': 'три акции раскрыты; только число пунктов',
  'flow.target': 'Целевая свеча',
  'flow.targetText': 'P₁ — закрытие следующей минуты',
  'flow.settle': 'Расчёт и проверка',
  'flow.settleText': 'выплаты по точности; пакет проверки',
  'flow.settleWr': 'Расчёт',
  'flow.settleTextWr': 'выигрывают угадавшие направление; доля — по точности',

  // ── категория столов ──
  'cat.n10': 'Начальный',
  'cat.n50': 'Стандартный',
  'cat.n200': 'Высокий',
  'cat.anteN': 'взнос N',
  'cat.players': 'Игроков',
  'cat.rounds': 'Круги',
  'cat.roundsValue': '3 × {s} с',
  'cat.commission': 'Комиссия',
  'cat.tables': 'Столы',
  'cat.roomsCount': '{rooms} · игроков {seated}',
  'cat.noOpen': 'нет открытых',
  'cat.newTable': 'Будет создан новый стол.',
  'cat.return': 'Вернуться за стол',
  'cat.sit': 'Сесть за стол',
  notEnough: 'Недостаточно кредитов для взноса.',

  // ── строка стола ──
  'room.playing': 'идёт розыгрыш',
  'room.startIn': 'старт через {n} с',
  'room.settling': 'расчёт',
  'room.ready': 'готовы {ready} из {min}',
  'room.taken': 'занято {seated} из {max}',
  'room.open': 'Открыть',
  'room.watch': 'Смотреть',

  // ── ожидание игроков ──
  'wr.startIn': 'Розыгрыш начнётся через {n} с',
  'wr.waitMore': 'Ждём ещё {n} подтверждение|Ждём ещё {n} подтверждения|Ждём ещё {n} подтверждений',
  'wr.allReady': 'Все готовы',
  'wr.preparing': 'Подготовка следующего розыгрыша',
  'wr.summary': 'Стол {ante|cr} · {min}–{max} игроков · за столом {seated}, готовы {ready}',
  'wr.botsNote': 'Если людей не хватит, стол доберут боты (они помечены).',
  'wr.spectating': 'Вы наблюдаете за столом.',
  'wr.confirmed': '✓ Участие подтверждено.',
  'wr.anteOnStart': 'Взнос {ante|cr} спишется при старте.',
  'wr.cancel': 'Отменить участие',
  'wr.join': 'Участвовать · взнос {ante|cr}',
  'wr.yourBalance': 'Ваш баланс {amount|cr}',
  'wr.seats': 'Места за столом',
  'wr.you': 'вы',
  'wr.gamesCount': 'розыгрышей: {n}',
  'wr.winRateShort': 'WR',
  'wr.offline': 'нет связи',
  'wr.ready': 'готов',
  'wr.waiting': 'ожидает',
  'wr.free': 'свободно',

  // ── правила ──
  'rules.title': 'Правила «Рыночного стола»',
  'rules.demo': 'Демо с игровыми кредитами. Реальных денег, платежей, покупки или вывода кредитов нет. Не является торговой рекомендацией.',
  'rules.indexTitle': 'Игровой индекс',
  'rules.indexText':
    'Перед каждым розыгрышем сервер случайно выбирает три разные акции из открытого набора ликвидных акций S&P 500. Индекс — равновзвешенная комбинация их процентных изменений относительно закрытия бара P₀:',
  'rules.index1': 'Bᵢ — цена закрытия акции на баре P₀; шаг цены {tick} пункта; округление к ближайшему шагу, половина — вверх.',
  'rules.index2': 'O/C бара — индекс по открытиям/закрытиям; H/L — по максимумам/минимумам компонентов (оценка сверху/снизу), но не уже O и C.',
  'rules.index3': 'Минута без сделок по акции — используется её последняя цена.',
  'rules.index4': '«Активность» — средний по трём акциям объём минуты, делённый на средний объём акции в окне истории (1 = обычно). VWAP* взвешен по активности.',
  'rules.index5': 'Формула открыта; скрыт только состав тройки — до третьего круга. Хеш-обязательство публикуется до ставок и раскрывается после расчёта.',
  'rules.flowTitle': 'Ход розыгрыша',
  'rules.flow1': 'Взнос N вносится в банк, фиксируется P₀.',
  'rules.flow2': 'Круг 1: график без шкалы, выбор направления (выше/ниже) и ставки.',
  'rules.flow3': 'Круг 2: открывается шкала цен и расстояний в пунктах. Направление можно оставить или изменить.',
  'rules.flow4': 'Круг 3: открывается состав. Направление уже не меняется — укажите строго положительное число пунктов (шаг {tick}).',
  'rules.flow5': 'Фиксация. P₁ — закрытие следующей минутной свечи; Δ = P₁ − P₀.',
  'rules.actionsTitle': 'Действия',
  'rules.actionsText':
    'Пас, чек, ставка, колл, райз (не более одного повышения после первой ставки в круге), олл-ин (с побочными банками). Время на ход — {s} с; по тайм-ауту — чек, если возможно, иначе пас. В конце круга пасует только тот, у кого истекло время хода. Кто не успел получить ход, остаётся в игре: неуравнённая часть ставки возвращается. Без полного прогноза к фиксации участник выбывает.',
  'rules.payoutTitle': 'Победители и выплаты',
  'rules.payout1': 'Неверное направление — всегда проигрыш, даже при точном числе пунктов.',
  'rules.payout2':
    'Для угадавших: ошибка = |прогноз − |Δ||; вес = вклад_в_банк / (1 + ошибка / {tick}). Банк делится пропорционально весам; остатки 0,01 кр. — методом наибольших остатков, при равенстве — по порядку хода.',
  'rules.payout3': 'Каждый побочный банк рассчитывается отдельно; на него претендуют только внёсшие в него и не спасовавшие. Банк, где нет угадавших, возвращается внёсшим.',
  'rules.payout4': 'Отмена с полным возвратом и нулевой комиссией: P₁ = P₀; никто из оставшихся не угадал направление; нет достоверных данных.',
  'rules.payout5': 'Все, кроме одного, спасовали — оставшийся забирает банк без проверки прогноза.',
  'rules.exampleTitle': 'Пример',
  'rules.exampleText':
    'Четыре игрока, взнос 10 кр.; Δ = +2,00. Игрок A: «выше 2,00» (ошибка 0, вес 10), B: «выше 2,25» (ошибка 0,25 = 1 шаг, вес 10/2 = 5), C и D — «ниже». Банк 40 кр., комиссия 5% = 2 кр.; к распределению 38 кр.: A — 25,33 кр., B — 12,67 кр.',
  'rules.commissionTitle': 'Комиссия',
  'rules.commissionText':
    '{pct}% от новых кредитов, внесённых в банк в каждом круге (в первом — вместе со взносами). Ранее внесённое и возвращённое не облагается; при отмене комиссия не удерживается.',
  'rules.capOne': 'один взнос',
  'rules.capMany': '{n} взнос|{n} взноса|{n} взносов',
  'rules.cap': 'Потолок — {antes} N за круг, то есть не более {max}N за розыгрыш (как потолок рейка в покере).',
  'rules.retained': 'Удержанное поступает на отдельный счёт банка демо.',
  'rules.hotkeysTitle': 'Горячие клавиши',
  'rules.hotkeys': '↑/↓ направление · +/− пункты (Shift ×4) · F пас · C чек/колл · B ставка/райз · A олл-ин · Enter подтвердить · Esc отмена',
};
